// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const YouTube: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44">
            <g fill="none" fillRule="evenodd">
                <circle cx="22" cy="22" r="21.5" stroke="#FFF" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M35.436 15.973a3.394 3.394 0 0 0-2.387-2.405C30.943 13 22.5 13 22.5 13s-8.443 0-10.549.568a3.394 3.394 0 0 0-2.387 2.405C9 18.093 9 22.519 9 22.519s0 4.426.564 6.547c.31 1.17 1.226 2.053 2.387 2.366C14.057 32 22.5 32 22.5 32s8.443 0 10.549-.568c1.161-.313 2.076-1.196 2.387-2.366.564-2.121.564-6.547.564-6.547s0-4.425-.564-6.546ZM20 27v-8l7 4-7 4Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(YouTube);
